export const SERVICE_TRIPCODE_DATA = 'SERVICE_TRIPCODE_DATA'
export const SERVICE_CATEGORY_DATA = 'SERVICE_CATEGORY_DATA'
export const SERVICE_MANAGE_TABLE_DATA = 'SERVICE_MANAGE_TABLE_DATA'
export const SERVICE_DEPOT_LIST = 'SERVICE_DEPOT_LIST'
export const SERVICE_CHART_LIST = 'SERVICE_CHART_LIST'
export const SERVICE_ROUTE_DETAILS="SERVICE_ROUTE_DETAILS"
export const SERVICE_STIP_LIST="SERVICE_STIP_LIST"
export const DROPPING_POINT="DROPPING_POINT"
export const BOARDING_POINT="BOARDING_POINT"
export const SERVICE_CITY_LIST="SERVICE_CITY_LIST"
export const SERVICE_CANCEL_DATA = 'SERVICE_CANCEL_DATA'
export const SERVICE_DEPOT_LISTV2 = 'SERVICE_DEPOT_LISTV2'

